import { executeRequest, JFSRequest } from '@jfs/network'
import { jsonToGraphQLQuery } from 'json-to-graphql-query'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfigWithTraceId } from './config'

const responseParser = (response: any) => {
  return response?.data?.data !== null
    ? response?.data?.data
    : response?.data?.errors?.[0]?.exception?.emsErrorCodeDetailsDto?.channelDesc ??
        response?.data?.errors?.[0]?.exception?.message ??
        response?.data?.errors?.[0]?.message
}

const getRiskSettingsBody = (searchString: string) => {
  const queryObj = {
    findEntity: {
      __args: {
        entityId: searchString,
      },
      riskSettings: {
        configurations: {
          configType: true,
          configValues: {
            key: true,
            value: true,
          },
        },
      },
    },
  }
  const query = `{${jsonToGraphQLQuery(queryObj, { pretty: false })}}`
  console.log('getRiskSettingsBody query: ', query)
  return query
}

const getEntityDetailsBody = (searchString: string) => {
  const queryObj = {
    findEntity: {
      __args: {
        entityId: searchString,
      },
      entity: {
        identificationNumber: true,
        legalName: true,
        businessName: true,
        merchantOtpDate: true,
        deviceOtpDate: true,
        status: true,
        legalOwnerName: true,
        ownerType: true,
        merchantLevel: true,
        name: true,
        defPostingEntity: true,
        oldStatus: true,
        activatedAt: true,
        terminatedAt: true,
        masParentId: true,
      },
      businessProfile: {
        ownershipType: true,
        businessChannel: true,
        setUpLevel: true,
        premiseType: true,
        businessPan: true,
        webAddress: true,
        storeType: true,
        pharmacistName: true,
        pharmacyCouncilNumber: true,
        yearsInBusiness: true,
        mccCode: true,
        dailyTransactionVolume: true,
        dailyTransactionValue: true,
        marketPlace: true,
        merchIrctcFlag: true,
        agentId: true,
        annualRevenueSegment: true,
      },
      authorisedSignatoryDetails: {
        authSigDOB: true,
        authSigFirstname: true,
        authSigMidname: true,
        authSigLastname: true,
        authSigGender: true,
        authSignDOC: true,
        authSigSalutation: true,
        locLangMerchdesc: true,
      },
      contactDetails: {
        mobileNumber: true,
        firstName: true,
        lastName: true,
        emailId: true,
        gender: true,
        landlineNumber: true,
        address1: true,
        address2: true,
        city: true,
        state: true,
        pincode: true,
        role: true,
        dateOfBirth: true,
        countryCode: true,
        country: true,
        websiteUrl: true,
        type: true,
        salutation: true,
        phone1: true,
        phone2: true,
        phoneExt: true,
        professionalTitle: true,
        fax: true,
      },
      addressDetails: {
        addressType: true,
        pincode: true,
        state: true,
        countryCode: true,
        latitude: true,
        longitude: true,
        addressRole: true,
        addressLine1: true,
        addressLine2: true,
        addressLine3: true,
        addressLine4: true,
        city: true,
        phone1: true,
        phone2: true,
        fax: true,
        emailAddr: true,
        stateAbbrev: true,
        geoCode: true,
        country: true,
      },
      gstDetails: {
        gstin: true,
        merchantCategory: true,
        dealerCategory: true,
        typeOfBusiness: true,
        jioGST: true,
      },
      settlementDetails: {
        accountNumber: true,
        ifsCode: true,
        beneficiaryName: true,
        settlementFrequency: true,
        settlPlanId: true,
        settlementStatus: true,
        acctPostingType: true,
        acctType: true,
        entityAcctCurr: true,
        entityAcctId: true,
        setupCompleteInd: true,
        effectiveDate: true,
        entityAcctDesc: true,
        settlAcctNbr: true,
      },
      feePackageDetails: {
        feePkgId: true,
        inheritParentFeePackage: true,
      },
      programCategoryDetails: {
        programId: true,
        referenceId: true,
      },
      kycDetails: {
        documentCategory: true,
        jdmsId: true,
        documentNumber: true,
        docSubmitted: true,
        expiryDate: true,
        chequeLeafFlag: true,
      },
      terminalDetails: {
        terminalId: true,
        mid: true,
        terminalType: true,
        mobileNumber: true,
        nickName: true,
        status: true,
        primary: true,
        firstName: true,
        posMsgBrand: true,
        closeDate: true,
        dailyTransactionVolume: true,
        dailyTransactionValue: true,
        terminalConfigurationDetails: {
          key: true,
          value: true,
        },
        vpaLinkingDetails: {
          handle: true,
        },
        device: {
          deviceStatus: true,
          deviceSerialNo: true,
          deviceLinkingStatus: true,
          deviceType: true,
        },
      },
      riskSettings: {
        configurations: {
          configType: true,
          configValues: {
            key: true,
            value: true,
          },
        },
      },
      unusedMASConfigResponse: {
        configurations: {
          configType: true,
          configValues: {
            key: true,
            value: true,
          },
        },
      },
      notifyDetails: {
        ccMerchFlag: true,
        customerSet: true,
        emailId: true,
        merchantId: true,
        eventId: true,
        institutionId: true,
        mailflag: true,
        merchantSet: true,
        mobileNbr: true,
        notifyFlag: true,
        notifyLevel: true,
        pushFlag: true,
        smsFlag: true,
        terminalId: true,
      },
    },
  }

  const query = `{${jsonToGraphQLQuery(queryObj, { pretty: false })}}`
  console.log('fetchEntityDetailsGetMerchantReq query: ', query)
  return query
}

const fetchEntityDetailsGetMerchantReq = (
  searchString: string,
  fetchQuery: string = 'ALL',
  tokens: any,
  traceId: string,
) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getEntityDetails),
    method: 'POST',
    cache: false,
    config: sitConfigWithTraceId(tokens, traceId),
    headers: getHeaders(),
    body:
      fetchQuery === 'ALL'
        ? getEntityDetailsBody(searchString)
        : fetchQuery === 'riskSettings'
        ? getRiskSettingsBody(searchString)
        : getEntityDetailsBody(searchString),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { fetchEntityDetailsGetMerchantReq }
